import { z } from 'zod';

export const PointSchema = z.object({
  type: z.literal('Point'),
  coordinates: z.tuple([z.number(), z.number()]),
});
export type Point = z.infer<typeof PointSchema>;

export const LineStringSchema = z.object({
  type: z.literal('LineString'),
  coordinates: z.array(z.tuple([z.number(), z.number()])),
});
export type LineString = z.infer<typeof LineStringSchema>;

export const PolygonSchema = z.object({
  type: z.literal('Polygon'),
  coordinates: z.array(z.array(z.tuple([z.number(), z.number()]))),
});
export type Polygon = z.infer<typeof PolygonSchema>;

export const MultiPolygonSchema = z.object({
  type: z.literal('MultiPolygon'),
  coordinates: z.array(z.array(z.array(z.tuple([z.number(), z.number()])))),
});
export type MultiPolygon = z.infer<typeof MultiPolygonSchema>;

export const MultiPointSchema = z.object({
  type: z.literal('MultiPoint'),
  coordinates: z.array(z.tuple([z.number(), z.number()])),
});
export type MultiPoint = z.infer<typeof MultiPointSchema>;

export const MultiLineStringSchema = z.object({
  type: z.literal('MultiLineString'),
  coordinates: z.array(z.array(z.tuple([z.number(), z.number()]))),
});
export type MultiLineString = z.infer<typeof MultiLineStringSchema>;

/** Any geometry an active-fire feature can carry: a perimeter polygon when one
 *  was matched, otherwise the incident point. */
export const PointOrPolygonSchema = z.union([
  PointSchema,
  PolygonSchema,
  MultiPolygonSchema,
]);
export type PointOrPolygon = z.infer<typeof PointOrPolygonSchema>;
